// Lightweight one-shot SFX playback. Audio elements are cached per path and rewound before each
// play so rapid repeat clicks (e.g. double-clicking a button) always restart the sound.
const cache = new Map();
function play(path) {
    let audio = cache.get(path);
    if (!audio) {
        audio = new Audio(path);
        cache.set(path, audio);
    }
    audio.currentTime = 0;
    void audio.play().catch(() => { });
}
export function playUiClick() {
    play("/assets/sounds/ui/click_003.ogg");
}
export function playBuildingRedirect() {
    play("/assets/sounds/ui/switch_002.ogg");
}
export function playBuildingPlaced() {
    play("/assets/sounds/ui/confirmation_004.ogg");
}
